import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[txtbAutofocusElem]',
  standalone: false,
})
export class AutoFocusDirective implements AfterViewInit {
  @Input() focusDelay = 0;
  @Input() blockAutofocus = false;
  constructor(private host: ElementRef) {
  }

  ngAfterViewInit(): void {
    this.addFocus();
  }

  addFocus(): void {
    !this.blockAutofocus &&
      setTimeout(() => this.host.nativeElement.focus({ preventScroll: true }), this.focusDelay);
  }
}
